const DEFAULT_OPTION_CONFIG = {
    schedule: {
        allowedUnits: ['DAY', 'WEEK'],
        allowedTimings: ['MINUS', 'PLUS', 'EQUAL'],
        defaultCount: 7,
        defaultUnit: 'DAY',
        defaultTiming: 'MINUS',
        defaultTimingType: 'AFTERNOON',
        minCount: 0,
        maxCount: null,
        countEditable: true,
        timingEditable: true,
        canDisable: true,
    },
    messageTypes: {
        default: ['SMART_PUSH'],
        disabled: [],
    },
    receiverSegmentLimit: 3,
    initialAudienceConfirmation: null,
    oneTime: false,
    autoInputWordGroup: 'FUNCTION_SPECIFIC',
    description: null,
};

const SAME_DAY_SCHEDULE = {
    allowedTimings: ['EQUAL'],
    defaultCount: 0,
    defaultTiming: 'EQUAL',
};

/** 자동알림 유형별 화면 정책입니다. */
export const AUTO_MESSAGE_OPTION_CONFIG = {
    CUSTOMER_SEGMENT_ENTRY_ALARM: {
        schedule: {
            allowedUnits: ['DAY'],
            allowedTimings: ['EQUAL', 'PLUS'],
            defaultCount: 0,
            defaultUnit: 'DAY',
            defaultTiming: 'EQUAL',
            defaultTimingType: 'MORNING',
            minCount: 0,
            maxCount: 30,
            countRanges: {
                EQUAL: { min: 0, max: 0 },
                PLUS: { min: 1, max: 30 },
            },
            scheduleLabel: '세그먼트 인입 확인',
            sameDayLabel: null,
            hideCountOnSameDay: true,
        },
        messageTypes: {
            default: ['SMART_PUSH'],
            disabled: ['KAKAO_ALIM_TALK'],
        },
        receiverSegmentLimit: 1,
        initialAudienceConfirmation: {
            title: '현재 고객도 전송 대상에 포함됩니다',
            promptOnReactivation: false,
            targetScope: 'CURRENT_AND_FUTURE',
            cancelText: '취소',
            confirmText: '진행',
            description:
                '자동문자를 저장하면 현재 고객은 저장 시점에 세그먼트에 인입된 것으로 간주되며, 설정한 전송 기준에 따라 발송 대상에 포함됩니다. 계속 진행하시겠습니까?',
        },
        autoInputWordGroup: 'BASE',
        description:
            '* 처음 설정하거나 대상 세그먼트를 변경하면 현재 세그먼트 고객도 저장 시점에 인입된 것으로 간주됩니다. 비활성화 후 다시 활성화하면 기존 인입 추적을 이어갑니다.',
    },
    CUSTOMER_NON_ATTENDANCE: {
        schedule: {
            defaultTiming: 'PLUS',
            timingEditable: false,
        },
    },
    MEMBER_TICKET_EXPIRE_DATE_ALARM: {
        schedule: {
            ...SAME_DAY_SCHEDULE,
            countEditable: false,
        },
    },
    LESSON_TICKET_EXPIRE_DATE_ALARM: {
        schedule: {
            ...SAME_DAY_SCHEDULE,
            countEditable: false,
        },
    },
    LESSON_PROGRAM_EXPIRE_DATE_ALARM: {
        schedule: SAME_DAY_SCHEDULE,
    },
    RENTAL_PROGRAM_EXPIRE_DATE_ALARM: {
        schedule: SAME_DAY_SCHEDULE,
    },
    FACILITY_TICKET_EXPIRE_DATE_ALARM: {
        schedule: SAME_DAY_SCHEDULE,
    },
    ENTRY_TICKET_EXPIRE_DATE_ALARM: {
        schedule: SAME_DAY_SCHEDULE,
    },
    CLASS_TICKET_EXPIRE_DATE_ALARM: {
        schedule: SAME_DAY_SCHEDULE,
    },
    LOCKER_EXPIRE_DATE_ALARM: {
        schedule: SAME_DAY_SCHEDULE,
    },
    SPORTS_EXPIRE_DATE_ALARM: {
        schedule: SAME_DAY_SCHEDULE,
    },
    RENTAL_EXPIRE_DATE_ALARM: {
        schedule: SAME_DAY_SCHEDULE,
    },
    CUSTOMER_BIRTHDAY_ALARM: {
        schedule: SAME_DAY_SCHEDULE,
        messageTypes: { disabled: ['KAKAO_ALIM_TALK'] },
    },
    ACTIVE_CUSTOMER_ALARM: {
        schedule: { ...SAME_DAY_SCHEDULE, canDisable: false },
        messageTypes: { disabled: ['KAKAO_ALIM_TALK'] },
        oneTime: true,
    },
    INACTIVE_CUSTOMER_ALARM: {
        schedule: { ...SAME_DAY_SCHEDULE, canDisable: false },
        messageTypes: { disabled: ['KAKAO_ALIM_TALK'] },
        oneTime: true,
    },
};

/** 함수 유형에 맞는 화면 정책을 반환합니다. */
export const getAutoMessageOptionConfig = (functionType = '') => {
    const baseFunctionType = functionType.replace(/_WITH_MILEAGE$/, '');
    const optionConfig = AUTO_MESSAGE_OPTION_CONFIG[baseFunctionType] || {};

    return {
        ...DEFAULT_OPTION_CONFIG,
        ...optionConfig,
        schedule: {
            ...DEFAULT_OPTION_CONFIG.schedule,
            ...(optionConfig.schedule || {}),
        },
        messageTypes: {
            ...DEFAULT_OPTION_CONFIG.messageTypes,
            ...(optionConfig.messageTypes || {}),
        },
    };
};
